export default __webpack_public_path__ + "static/media/myPortfolio.68eb71f8.PNG";